import React from "react";
import { Column } from "react-table";
import Svg from "components/common/SVG/Svg";
import { Link } from "react-router-dom";
import { hostToolLinks } from "constants/AppLinks";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";

const ToggleOffIcon = BsToggleOff as any;
const ToggleOnIcon = BsToggleOn as any;

type TRow = {
  id: string;
  name: string;
  isActive: boolean;
  rowVersion?: string;
};

type TProps = {
  handleDropdownAction: (
    row: TRow,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    modalKey: string,
  ) => void;
};

const TenantsManagementTableColumns = ({ handleDropdownAction }: TProps) => {
  const checkStatus = (isActive: boolean): string => (isActive ? "Active" : "Inactive");
  const checkLabelStatus = (isActive: boolean): string => (isActive ? "success" : "danger");

  return React.useMemo(
    () =>
      [
        {
          Header: "Name",
          accessor: "name",
          disableSortBy: false,
          Cell: ({ row }: any) => {
            const { original } = row;
            const { id, name } = original;

            return (
              <Link to={`/host/${hostToolLinks.tenantDetails.replace(":tenantId", id)}`}>
                {name}
              </Link>
            );
          },
        },
        {
          Header: "Status",
          accessor: "isActive",
          disableSortBy: true,
          Cell: ({
            row: {
              original: { isActive },
            },
          }: any) => (
            <div className="text-center">
              <span className={`badge bg-${checkLabelStatus(isActive)}`}>
                {checkStatus(isActive)}
              </span>
            </div>
          ),
        },
        {
          Header: "Actions",
          accessor: "actions",
          disableSortBy: true,
          Cell: ({ row }: any) => {
            const { original } = row;
            const { id, isActive } = original;

            return (
              <div className="text-center">
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id={`tenantActionDropdown_${id}`}
                  >
                    {Svg({ icon: "threeDots", width: 20, height: 20 })}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby={`tenantActionDropdown_${id}`}>
                    <li>
                      <Link
                        to={`/host/${hostToolLinks.tenantDetails.replace(":tenantId", id)}`}
                        className="dropdown-item"
                      >
                        <Svg icon="eyes" width={15} height={15} />
                        <span className="ms-2">View Details</span>
                      </Link>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={(event) => handleDropdownAction(original, event, "editTenant")}
                      >
                        <Svg icon="pencil" width={15} height={15} />
                        <span className="ms-2">Edit</span>
                      </button>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={(event) =>
                          handleDropdownAction(original, event, "toggleTenantStatus")
                        }
                      >
                        {isActive ? (
                          <ToggleOffIcon size={15} style={{ color: "#dc3545" }} />
                        ) : (
                          <ToggleOnIcon size={15} style={{ color: "#28a745" }} />
                        )}
                        <span className="ms-2">{isActive ? "Deactivate" : "Activate"}</span>
                      </button>
                      <button
                        type="button"
                        className="dropdown-item text-danger"
                        onClick={(event) => handleDropdownAction(original, event, "deleteTenant")}
                      >
                        <Svg icon="trash" width={15} height={15} />
                        <span className="ms-2">Delete</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            );
          },
        },
      ] as Column<object>[],
    [handleDropdownAction],
  );
};

export default TenantsManagementTableColumns;
